module.exports = __webpack_public_path__ + "static/img/preview-04.71eafb3a.webp";